export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname

export const toTermsAndConditions = () => `https://www.ccrpartners.co/loan-terms-and-conditions`

export const toNotice = () => `https://www.ccrpartners.co/data-protection-notice`

export const privacyPolicy = () => `https://www.ccrpartners.co/privacy-policy`
